import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import Icon from 'shared/components/Icon';
import { Currency } from '../Currency';
import { ActivityType } from 'shared/models';

export type CreditStatusProps = {
  showCreditStatus: boolean;
  transaction: Transaction;
  type: any;
};

type Transaction = {
  amount: number;
  amountOfCreditPaid: number;
  id: string;
};

export function CreditStatus(props: CreditStatusProps) {
  const { showCreditStatus, transaction, type } = props;
  const { amount, amountOfCreditPaid, id } = transaction;

  const renderStatus = () => {
    if (amountOfCreditPaid === null || !showCreditStatus) {
      return null;
    }

    if (amountOfCreditPaid === 0 && amount !== 0) {
      return (
        <div id={`transaction-status-${id}`}>
          <Icon className="text-danger mr-1" icon="error" />
          <UncontrolledTooltip placement="right" target={`transaction-status-${id}`}>
            This credit has no settlements.
          </UncontrolledTooltip>
        </div>
      );
    } else if (amountOfCreditPaid < amount) {
      return (
        <div id={`transaction-status-${id}`}>
          <Icon className="text-warning mr-1" icon="warning" />
          <UncontrolledTooltip placement="right" target={`transaction-status-${id}`}>
            This credit has a partial settlement of <Currency amount={amountOfCreditPaid} />.
          </UncontrolledTooltip>
        </div>
      );
    } else if (amountOfCreditPaid === amount || amount === 0) {
      return (
        <div id={`transaction-status-${id}`}>
          <Icon className="text-success mr-1" icon="check_circle" />
          <UncontrolledTooltip placement="right" target={`transaction-status-${id}`}>
            This credit is fully settled.
          </UncontrolledTooltip>
        </div>
      );
    }

    return null;
  };

  if (type === ActivityType.Credit && amount !== null) {
    return (
      <span className="inline-popover">
        {renderStatus()}
        <Currency amount={amount} />
      </span>
    );
  }

  return null;
}
